import { useMemo } from 'react'
import { isAssistantAnswerLoading } from '@/constants/chat'
import { normalizeMessages } from '@/features/chat/messageNormalize'

/**
 * @param {ReturnType<typeof import('./useChatPersistedSlices').useChatPersistedSlices>} state
 * @param {string | null} displayThreadId
 */
export function useThreadMessagesState(state, displayThreadId) {
  const { messagesByThreadId } = state

  const activeMessages = useMemo(() => {
    if (!displayThreadId) return []
    return normalizeMessages(messagesByThreadId[displayThreadId] ?? [])
  }, [messagesByThreadId, displayThreadId])

  const chatComposerLocked = useMemo(() => {
    const pending = activeMessages.some(
      (m) => m.role === 'assistant' && isAssistantAnswerLoading(m),
    )
    const openAgentQuestion = activeMessages.some(
      (m) => m.role === 'assistant' && m.agentQuestion?.status === 'open',
    )
    // Only an *open* card locks. A submitted one stays on screen as a record of
    // what was answered, and locking on that would strand the thread forever.
    const openClarification = activeMessages.some(
      (m) =>
        m.role === 'assistant' &&
        (m.blocks ?? []).some(
          (block) => block?.type === 'clarification_card' && block.status !== 'submitted',
        ),
    )
    return pending || openAgentQuestion || openClarification
  }, [activeMessages])

  return { activeMessages, chatComposerLocked }
}
